import React from 'react';
import {Card, CardContent, Grid, Typography, } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import Card64Image from 'components/card64Image';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';

const DetalleDeLaVallaFija = ({title, openFullScreenDialog, handleClose, datosGeneralesDelTarifario}) => {
  const classes = styles();
  const {tipoDeVallaFija, costo, especDeContratacion, departamento, municipio, altoValla, anchoValla, coordenadas, sentidoDeVisualizacion, descripcionUbicacion, imagenDeValla} = datosGeneralesDelTarifario;

  return (
    <DialogoPantallaCompleta
      openFullScreenDialog={openFullScreenDialog}
      handleClose={handleClose}
      title={title}
      fullscreen={true}
      showButtonClose={false}
      showIconButton={true}
    >
    <Card className={classes.root}>
        <CardContent>
            <Grid container justify="space-between" alignItems="center" spacing={4} wrap={"wrap"} >
                <Grid item xs={12} md={6}>
                  <TituloConIcono title={"Datos del medio"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <ElementoDelCard title={'Tipo de valla:'} label={tipoDeVallaFija?.descripcion || ""}/>
                  <ElementoDelCard title={'Costo:'} label={costo}/>
                  <ElementoDelCard title={'Departamento:'} label={departamento?.nombre || ""}/>
                  <ElementoDelCard title={'Municipio:'} label={municipio?.nombre || ""}/>
                  <ElementoDelCard title={'Especificaciones de contratación:'} label={especDeContratacion || ""}/>
                </Grid>

                <Grid item xs={12} md={6}>
                    <TituloConIcono title={"Datos de la valla fija"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                    <ElementoDelCard title={'Ancho:'} label={anchoValla || ""}/>
                    <ElementoDelCard title={'Alto:'} label={ altoValla || ""}/>
                    <ElementoDelCard title={'Coordenadas:'} label={coordenadas || ""}/>
                    <ElementoDelCard title={'Sentido de visualización:'} label={sentidoDeVisualizacion?.descripcion || ""}/>
                    <ElementoDelCard title={'ubicación de la pantalla:'} label={descripcionUbicacion || ""}/>
                </Grid>
                <Grid item xs={12} >
                {imagenDeValla ? (
                      <Grid item xs={12} sm={6} md={4} lg={3} >
                          <Card64Image
                              label={"LOGO"} image={imagenDeValla} title={"Imagen de la valla"} src={imagenDeValla} showTitle={false} showTitle2={true} documentName={imagenDeValla} getDocumentOfPoliticalOrganization={undefined} showButtonEditDocument={false} handleClickUpdateDocument={undefined}
                              showInMovil={true} firstTitle={""} observacion={""} idDocumento={"idDocumento"} idEstadoDocumento={""}
                          />
                      </Grid>
                  ): <Typography variant="h5" component="div" align='center'>No Adjunto imagen de la valla <br/> </Typography>}
                </Grid>
            </Grid>
        </CardContent>
    </Card>
    </DialogoPantallaCompleta>
  );
}

export default DetalleDeLaVallaFija;